import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice } from 'Modules'
import { partnerApi, partnerSlice, PartnerNS } from 'Pages/smsExpansion'

function* updatePartner(action: PartnerNS.UpdatePartner) {
	try {
		const { id, data, callback } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(partnerApi.updateOne, id, data)
		callback?.(res)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* partnerSaga() {
	yield* takeLatest(partnerSlice.actions.updatePartner, updatePartner)
}
